import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Dimension } from '../../../../../features/dimension/types/Dimension'
import DimensionTreeSelect from '../../../../../features/dimension/components/DimensionTreeSelect'
import { useLegalMoveTargets } from '../hooks/useLegalMoveTargets'

const ROOT_VALUE = '__root__'

interface ParentDimensionFieldProps {
  flatList: Dimension[]
  excludeIds?: string[]
  value?: string
  onChange?: (value: string | undefined) => void
  disabled?: boolean
}

const ParentDimensionField: React.FC<ParentDimensionFieldProps> = ({
  flatList,
  excludeIds,
  value,
  onChange,
  disabled
}) => {
  const { t } = useTranslation()
  const { treeData } = useLegalMoveTargets(flatList, excludeIds ?? [])

  const treeDataWithRoot = useMemo(
    () => [
      { dimensionId: ROOT_VALUE, name: t('dimensionsPage:moveModalRootOption'), id: -1, companyId: '', order: 0 },
      ...treeData
    ],
    [treeData, t]
  )

  return (
    <DimensionTreeSelect
      style={{ width: '100%' }}
      disabled={disabled}
      treeData={treeDataWithRoot}
      value={value ?? ROOT_VALUE}
      onChange={newValue => onChange?.(newValue === ROOT_VALUE ? undefined : (newValue as string))}
    />
  )
}

export default ParentDimensionField
